import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

export interface AgGridTooltipCellRendererParams extends ICellRendererParams {
    getTooltipText: (params: AgGridTooltipCellRendererParams) => string;
    cellIcon?: string;
    isMultiline?: (params: AgGridTooltipCellRendererParams) => boolean;
}

@Component({
    selector: 'ag-grid-tooltip-cell-renderer',
    template: `
        <div
            helpTooltip
            [tooltipText]="tooltipText"
            [tooltipDelay]="0"
            [helpDisabled]="!tooltipText"
            [isMultiline]="isMultiline"
        >
            @if (cellText) {
                <span>{{ cellText }}</span>
            }
            @if (!cellText) {
                <span style="visibility: hidden;">x</span>
            }
            @if (cellIcon) {
                <i class="fa" [ngClass]="cellIcon"></i>
            }
        </div>
    `,
    standalone: false,
})
export class AgGridTooltipCellRendererComponent implements ICellRendererAngularComp {
    params: AgGridTooltipCellRendererParams;
    tooltipText: string;
    cellText: string;
    cellIcon: string;
    isMultiline: boolean;

    agInit(params: AgGridTooltipCellRendererParams): void {
        this.params = params;
        this.tooltipText = params.getTooltipText(params);
        this.isMultiline = params.isMultiline && params.isMultiline(params);
        if (params.cellIcon && this.tooltipText) {
            this.cellIcon = params.cellIcon;
        } else {
            this.cellText = params.valueFormatted || params.value;
        }
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
